<template>
  <div :class="`${$options.name} tw:bg-default-000`">
    <hr class="edrone-hr" />
    <div class="tw:py-2 tw:sm:py-4 tw:px-4 tw:sm:px-6 tw:flex tw:justify-between tw:gap-2">
      <div class="tw:flex tw:gap-2">
        <!-- @slot Here go buttons on the left side -->
        <slot name="start"></slot>
      </div>
      <div class="tw:flex tw:gap-2">
        <!-- @slot Here go buttons on the right side -->
        <slot name="end"></slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "EdroneNavigationBottom",
});
</script>
